import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { GeoPaymentMethodPartialUpdatePayload } from '@/models/ps-management/ps-management.model';

export default class PartialUpdateGeoSinglePaymentMethodRequest
  extends ApiResourceMethod<{}> {
  public perform(payload: GeoPaymentMethodPartialUpdatePayload): Promise<{}> {
    return this.performer.requestWithMapper(
      {
        url: `${payload.billingPaymentMethodSettingsId}/switchOperation`,
        data: payload.data,
      },
      (response: BaseResponse<{}>) => {
        return response.data;
      },
    );
  }
}
